module.exports = __webpack_public_path__ + "static/seres-silk-duvet-3-27e0e3fc0c1802e64d1235dac30077e8.webp";